import { render, staticRenderFns } from "./ModalBanner.vue?vue&type=template&id=3da5e096&scoped=true"
import script from "./ModalBanner.vue?vue&type=script&lang=js"
export * from "./ModalBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da5e096",
  null
  
)

export default component.exports